import {
  createBaseQuery,
  createServerSideRequestOption,
  getBaseUrl,
} from "@/redux/config";
import { createApi } from "@reduxjs/toolkit/query/react";

export const getCompanyServiceUsers = async ({
  companyId,
  request,
}: {
  companyId: number;
  request: Request;
}) => {
  return await createServerSideRequestOption({
    url: `${getBaseUrl()}/api/v1/c/${companyId}/services/0/users/list-auth-services`,
    request: request,
    method: "GET",
  });
};

export const companyServiceUserApi = createApi({
  reducerPath: "companyServiceUserApi",
  baseQuery: createBaseQuery("/c/"),
  tagTypes: ["companyServiceUserApiUser", "companyServiceUserApiService"],
  endpoints: (build) => ({
    addUserToService: build.mutation<
      CompanyService,
      { companyId: number; serviceId: number; userId: number }
    >({
      query: ({ companyId, serviceId, userId }) => ({
        url: `${companyId}/services/${serviceId}/users/add/${userId}`,
        method: "POST",
        body: {},
      }),
      invalidatesTags: ["companyServiceUserApiService"],
    }),
    deleteUserFromService: build.mutation<
      void,
      { companyId: number; serviceId: number; userId: number }
    >({
      query: ({ companyId, serviceId, userId }) => ({
        url: `${companyId}/services/${serviceId}/users/remove/${userId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["companyServiceUserApiService"],
    }),
    listServicesByUserId: build.query<
      CompanyService[],
      { companyId: number; serviceId: number; userId: number }
    >({
      query: ({ companyId, userId, serviceId }) => ({
        url: `${companyId}/services/${serviceId}/users/list-services/${userId}`,
        method: "GET",
      }),
      providesTags: ["companyServiceUserApiService"],
    }),
    listUsersByServiceId: build.query<
      CompanyUser[],
      { companyId: number; serviceId: number }
    >({
      query: ({ companyId, serviceId }) => ({
        url: `${companyId}/services/${serviceId}/users/list-users`,
        method: "GET",
      }),
      providesTags: ["companyServiceUserApiUser"],
    }),
  }),
});
